/**
 * Destinations des appels à l'action de la landing.
 *
 * Tout est centralisé ici pour n'avoir qu'un seul endroit à corriger.
 */
export const SIGNUP_HREF = '/auth?mode=signup';
export const LOGIN_HREF = '/auth?mode=login';
// Corrigé le 2026-09-03 : pointait vers `/tableau-de-bord`, le vrai tableau
// de bord authentifié — `useTontineData` y détecte l'absence de session et
// fait `router.push('/auth')`, donc un visiteur anonyme qui cliquait
// « voir la démo » atterrissait sur l'écran de connexion après un flash de
// chargement. La landing annonçait une démo et livrait un mur d'auth. En
// attendant une vraie démo publique (sujet à part, pas un correctif de
// dernière minute), ce lien pointe vers la section qui montre réellement le
// produit sans exiger de compte.
export const HOW_IT_WORKS_HREF = '#sec-fonctionnement';
